<template>
  <div class="width-medium mx-auto">
    <f-button
      theme="primary"
      :disabled="actionInProgress || !subject || !subject.length ||!message || !message.length || !adviser.email"
      @click="sendTestEmail">
      {{ $t('communicationMail.sendTestMail') }}
    </f-button>
    <div class="card is-smallshadow mt-2 mb-2">
      <div class="card-body px-3 pt-3">
        <h2 class="heading-small" v-pure-html="$t('communicationSms.sendTestSmsText')"></h2>

        <validation-observer
          ref="communication-email-form"
          tag="form">
          <div class="form-group">
            <label for="name">{{ $t('communicationMail.subject') }} </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <f-input
                v-model="subject"
                :state="errors.length ? 'invalid' : null"/>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group mb-0">
            <label for="message">{{ $t('messageForm.writeTheMessage') }} </label>

            <validation-provider
              rules="required|max:9000"
              name="message"
              v-slot="{ errors }">
              <f-textarea
                v-model="message"
                :maxLength="200"
                :showCounter="true"
                :rows="4"
                :state="errors.length ? 'invalid' : null"/>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>

        <div>
          <f-file-input
            class="mt-3"
            id="emailAttachment"
            :label="$t('messageForm.addAttachment')"
            icon="attachment"
            accept=".pdf, .jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx"
            :multiple="true"
            :onChange="attachFiles"/>
        </div>

        <div
          v-if="files.length"
          class="flex flex-column mt-2 attach-files-list full-width">
          <span class="heading-tiny mb-2">{{ $t('messageForm.attachedFiles') }}:</span>
          <div
            v-for="(file, index) of files"
            :key="index"
            :class="{
              'attach-files-list-item flex flex-items-align-center': true,
              'mt-2': index > 0
            }">
            <div>
              <label>{{ $t('messageForm.fileName') }}</label>
              {{ file.name }}
            </div>

            <f-button
              class="ml-auto block"
              theme="danger"
              @click.prevent="removeFile(index)">
              {{ $t('messageForm.deleteFile') }}
            </f-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card is-smallshadow mt-2 mb-3">
      <div class="card-body px-3 pt-3">
        <div class="flex flex-align-items-center">
          <h2 class="heading-small">{{ $t('communicationSms.recipients') }}</h2>
          <div class="ml-auto small">{{ $t('communicationSms.customersChoose.choose') }} {{ receivers.length }} {{ $t('communicationSms.customersChoose.customers') }}</div>
        </div>

        <v-select
          v-if="!allCustomersSelected"
          :options="allAvailableCustomers"
          v-model="receivers"
          :reduce="(customer) => customer.id"
          :multiple="true"
          :placeholder="$t('communicationMail.selectRecipients')"
          label="name"
          class="mb-4-sm">
          <template slot="no-options">
            {{ $t('ui.noResultsForGivenPhrase') }}
          </template>
          <template
            slot="option"
            slot-scope="option">
            {{ option.name }} {{ option.surname }}
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            {{ option.name }} {{ option.surname }}
          </template>
        </v-select>

        <div class="flex flex-align-items-center flex-wrap flex-justify-content-between">
          <f-checkbox
            class="block mt-1 mr-5"
            v-model="allCustomersSelected"
            @change="selectAllCustomers()">
            {{ $t('communicationSms.sendForAll') }}
          </f-checkbox>

          <f-button
            v-if="!allCustomersSelected"
            class="mt-1 px-0"
            theme="text-alert"
            @click.prevent="emptyReceiversList">
            {{ $t('communicationSms.deselectAll') }}
          </f-button>
        </div>

      </div>
    </div>

    <div class="buttins-wrapper text-right">
      <f-button
        class="ml-auto"
        :disabled="actionInProgress || !subject || !subject.length ||!message || !message.length || !receivers.length"
        theme="primary"
        withArrow
        big
        @click.prevent="validateForm">
        {{ $t('communicationSms.messageSend') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'communication-email-form',
  props: {
    allAvailableCustomers: {
      type: Array,
      default: () => []
    },
    adviser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      message: '',
      subject: '',
      files: [],
      receivers: [],
      allCustomersSelected: false,
      actionInProgress: false
    };
  },
  mounted () {
  },
  methods: {
    submitForm () {
      this.actionInProgress = true;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/api/adviser/communications/emails/store';

      let fileParams = [];
      if (formDataToSend.files && formDataToSend.files.length) {
        fileParams.push('files');
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('registerMailSent.sendMessage'),
        successText: this.$t('communicationMail.sendEmailToCustomer'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('communicationSms.messageSendTo.messageSendToCustomerError'),
        successAction: () => {
          this.clearForm();
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      }, fileParams);
    },
    sendTestEmail () {
      this.actionInProgress = true;
      let formDataToSend = {
        email: this.adviser.email,
        subject: this.subject,
        message: this.message
      };

      FormUtils.submit(this, {
        endpoint: '/api/adviser/communications/emails/send-test',
        formData: formDataToSend,
        successTitle: this.$t('communicationMail.emailSend.emailSendSuccess'),
        successText: this.$t('communicationMail.emailSend.emailHasBeenSend'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('communicationMail.emailSend.emailSendError'),
        successAction: () => {
          this.clearForm();
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['communication-email-form'], this.submitForm);
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        subject: this.subject,
        message: this.message,
        receivers: this.receivers
      };

      if (this.files.length) {
        formDataToSend.files = [];

        for (let i = 0; i < this.files.length; i++) {
          formDataToSend.files.push(this.files[i]);
        }
      }

      return formDataToSend;
    },
    attachFiles (event) {
      this.files.push(event.target.files[0]);
    },
    removeFile (index) {
      this.files.splice(index, 1);
    },
    clearForm() {
      this.actionInProgress = false;
      this.subject = '';
      this.message = '';
      this.files = [];
      this.receivers = [];
      this.$refs['communication-email-form'].reset();
    },
    selectAllCustomers () {
      Vue.nextTick(() => {
        Vue.set(this, 'receivers', this.allAvailableCustomers.map(item => item.id));
      })
    },
    emptyReceiversList () {
      Vue.set(this, 'receivers', []);
    }
  }
};
</script>
